export default __webpack_public_path__ + "static/media/nazir.3bc42e64.jpeg";